import { AnalyseResponse } from "../types";

export const MOCK_ANALYSE_RESPONSE: AnalyseResponse = {
  // Goal "Earn an Initial Conversation" (Engage:) → selected phase = engage.
  // overall = round(0.6 * trustedPartner(63) + 0.4 * engage(42)) = 55.
  overallScore: 55,
  overallVerdict: "needs_improvement",
  issuesFound: 2,
  trustedPartner: { key: "trustedPartner", score: 63, weight: 60, summary: "Other-centered but applies some pressure" },
  selectedBlock: "engage",
  blocks: [
    { key: "engage", score: 42, weight: 40, summary: "Opener is self-focused" },
    { key: "discover", score: 61, weight: 0, summary: "Assumptive tone" },
    { key: "buildValue", score: 66, weight: 0, summary: "Weak differentiation" },
    { key: "advance", score: 81, weight: 0, summary: "Clear, low-friction CTA ✓" },
  ],
  coachingNotes: [
    {
      id: "trustedPartner-weak",
      severity: "issue",
      title: "Lead as a Trusted Partner",
      body:
        "The tone leans seller-centered and presses for a meeting. Drop the rope and let " +
        "the reader's context — not urgency — earn the next step.",
      block: "trustedPartner",
    },
    {
      id: "engage-self-centred",
      severity: "issue",
      title: "Opener is self-centred — Drop the Rope",
      body:
        "Your opener leads with \"I wanted to reach out…\" which focuses on you. " +
        "Use an Other-Centered Position to lead with the prospect's context instead.",
      block: "engage",
    },
  ],
  rewrite: {
    paragraphs: [
      { text: "Hi Sarah,", kind: "original" },
      {
        text:
          "I came across your team's recent Midwest expansion — congratulations on the growth. " +
          "Many sales leaders navigating similar transitions find that keeping messaging " +
          "consistent across a fast-growing team becomes the biggest challenge.",
        kind: "added",
      },
      {
        text:
          "I'd love to understand whether that's showing up for you — and if so, how you're currently handling it.",
        kind: "added",
      },
      {
        text: "Would a 20-minute call this week work? No agenda other than understanding your situation.",
        kind: "added",
      },
      { text: "Best,\nJames", kind: "original" },
    ],
    caption:
      "ASLAN+ rewrote the opener using an Other-Centered Position and removed the assumptive framing in paragraph 2.",
    scoreBefore: 58,
    scoreAfter: 82,
    suggestedSubject: "A quicker path to consistent messaging",
  },
  suggestedSubject: "A quicker path to consistent messaging",
};
